import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-shell" }
const _hoisted_2 = {
  key: 0,
  class: "error-banner"
}
const _hoisted_3 = {
  key: 1,
  class: "success-row"
}
const _hoisted_4 = { class: "success-subtitle" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "loading-row"
}
const _hoisted_7 = { class: "application-header" }
const _hoisted_8 = { class: "application-header__icon" }
const _hoisted_9 = { class: "application-header__copy" }
const _hoisted_10 = { class: "review-list" }
const _hoisted_11 = { class: "review-section" }
const _hoisted_12 = { class: "review-card" }
const _hoisted_13 = { class: "review-row review-row--title-bottom" }
const _hoisted_14 = { class: "review-section" }
const _hoisted_15 = { class: "review-card" }
const _hoisted_16 = { class: "review-row review-row--title-bottom" }
const _hoisted_17 = { class: "review-row review-row--title-bottom" }
const _hoisted_18 = { class: "review-row review-row--title-bottom" }
const _hoisted_19 = { class: "review-row review-row--title-bottom" }
const _hoisted_20 = { class: "review-section" }
const _hoisted_21 = { class: "review-card" }
const _hoisted_22 = { class: "review-row review-row--title-bottom" }
const _hoisted_23 = { class: "review-row review-row--title-bottom" }
const _hoisted_24 = { class: "review-row review-row--title-bottom" }
const _hoisted_25 = { class: "review-row review-row--title-bottom" }
const _hoisted_26 = { class: "review-section" }
const _hoisted_27 = { class: "review-card" }
const _hoisted_28 = { class: "text-capitalize" }
const _hoisted_29 = { class: "review-file" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = {
  key: 0,
  class: "review-section"
}
const _hoisted_32 = { class: "review-card" }
const _hoisted_33 = {
  key: 0,
  class: "card"
}
const _hoisted_34 = {
  key: 0,
  class: "section"
}
const _hoisted_35 = { class: "actions" }

import { computed, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import AppCard from "@/shared/components/ui/AppCard.vue";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { fetchCompanyDetails } from "@/modules/vendor/services/vendors.api";
import PaymentBlock from "@/shared/components/ui/flow/PaymentBlock.vue";
import MembershipPlans from "@/modules/vendor/components/MembershipPlans.vue";
import { useAppStore } from "@/shared/stores/app";
import {
  createVendorMembershipIntent,
  finalizeVendorMembership,
  sendVendorRequest,
  sendVendorRequestWithoutPrice,
} from "@/shared/services/vendor-requests.api";

type CompanyAddress = {
  city?: string | null;
  state?: string | null;
  country?: string | null;
  postal_code?: string | null;
};

type CompanyPlanPrice = {
  id: number;
  amount: number;
  billing_cycle?: string | null;
  interval_label?: string | null;
};

type CompanyPlan = {
  id: number;
  name: string;
  highlight: string | null;
  description: string[];
  prices: CompanyPlanPrice[];
};

type ApprovalContactInfo = {
  email: string;
  fname: string;
  lname: string;
  phone: string;
  email_alt: string | null;
  phone_alt: string | null;
};

type ApprovalAddressInfo = {
  lat: string | null;
  lng: string | null;
  zip: string;
  add1: string;
  add2: string;
  city: string;
  state: string;
  county: string | null;
  country: string | null;
  is_default: number;
  country_code: string | null;
};

type ApprovalDocument = {
  name: string;
  path: string;
  size: number;
  type: string;
  url: string | null;
  mime_type: string;
};

type ApprovalBusinessInfo = {
  business_name: string;
  business_type: string;
  business_email: string;
  business_phone: string;
};

type ApprovalInfo = {
  id: number;
  contact_info: ApprovalContactInfo;
  address_info: ApprovalAddressInfo;
  documents: ApprovalDocument[];
  business_info: ApprovalBusinessInfo;
};

type CompanyDetail = {
  name: string;
  code: string;
  phone: string | null;
  email: string | null;
  address: CompanyAddress;
  company_plans: CompanyPlan[];
  company?: {
    id: number;
    publishable_key: string;
  };
  application_status: string;
  application_id: number | null;
  approved: boolean;
  approval_info: ApprovalInfo | null;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplyForCompany',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const appStore = useAppStore();

const isLoading = ref(false);
const errorMessage = ref("");
const company = ref<CompanyDetail | null>(null);
const companyDisplayName = computed(() => String(company.value?.name || "").trim());
const hasCompanyPlans = computed(() => (company.value?.company_plans || []).length > 0);
const selectedPlanId = ref<number | null>(null);
const selectedPriceId = ref<number | null>(null);
const selectedBillingInterval = ref<"monthly" | "yearly">("monthly");
const selectedPlan = ref<CompanyPlan | null>(null);
const isSubmitting = ref(false);
const isSubmitted = ref(false);
const stripeConfig = reactive<{ publishableKey: string; stripeAccount: string }>({
  publishableKey: "",
  stripeAccount: "",
});
const paymentBlockRef = ref<{
  validate: () => Promise<void>;
  confirmPayment: (
    clientSecret: string,
    billingDetails: Record<string, unknown>
  ) => Promise<{ paymentIntentId?: string; paymentMethodId?: string }>;
  confirmSetup: (
    clientSecret: string,
    billingDetails: Record<string, unknown>
  ) => Promise<{ setupIntentId?: string; paymentMethodId?: string }>;
} | null>(null);

function getRouteCompanyId(): number | null {
  const raw = route.params.id;
  const value = Array.isArray(raw) ? raw[0] : raw;
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
}

const addressLine1 = computed(() => {
  const city = String(company.value?.address?.city || "").trim();
  const state = String(company.value?.address?.state || "").trim();
  if (city && state) return `${city}, ${state}`;
  return city || state || "—";
});

const addressLine2 = computed(() => {
  const country = String(company.value?.address?.country || "").trim();
  const postal = String(company.value?.address?.postal_code || "").trim();
  return [country, postal].filter(Boolean).join(" • ");
});

const companyPublishableKey = computed(
  () => company.value?.company?.publishable_key || ""
);

const approval = computed(() => {
  const info = company.value?.approval_info || null;
  const id =
    info && typeof info === "object" ? Number((info as ApprovalInfo).id) || null : null;
  const contactInfo =
    info && typeof info === "object" ? (info as ApprovalInfo).contact_info : null;
  const addressInfo =
    info && typeof info === "object" ? (info as ApprovalInfo).address_info : null;
  const businessInfo =
    info && typeof info === "object" ? (info as ApprovalInfo).business_info : null;
  const documentsRaw =
    info && typeof info === "object" ? (info as ApprovalInfo).documents : [];
  const documents = Array.isArray(documentsRaw) ? documentsRaw : [];
  const contactName = (() => {
    const name = `${String(contactInfo?.fname || "").trim()} ${String(
      contactInfo?.lname || ""
    ).trim()}`.trim();
    return name || "-";
  })();

  return {
    info,
    id,
    contactInfo,
    addressInfo,
    businessInfo,
    documents,
    contactName,
  };
});

function formatBytes(value: unknown) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return "";
  const units = ["B", "KB", "MB", "GB"];
  let size = n;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }
  const digits = unitIndex === 0 ? 0 : size >= 10 ? 1 : 2;
  return `${size.toFixed(digits)} ${units[unitIndex]}`;
}

// const selectedPlan = computed(() => {
//   const id = selectedPlanId.value;
//   if (!id) return null;
//   return (company.value?.company_plans || []).find((p) => p.id === id) || null;
// });

const selectedPrice = computed(() => {
  const plan = selectedPlan.value;
  const id = selectedPriceId.value;
  if (!plan || !id) return null;
  return (plan.prices || []).find((p) => p.id === id) || null;
});

function selectPlan(id: number) {
  selectedPlanId.value = id;
  const plan = (company.value?.company_plans || []).find((p) => p.id === id);
  selectedPlan.value = plan || null;
}

function resolvePriceIdForInterval(
  plan: CompanyPlan | null,
  interval: "monthly" | "yearly"
) {
  if (!plan?.prices?.length) return null;
  const matched = plan.prices.find((price: any) => {
    const billingCycle = String(price?.billing_cycle || "").toLowerCase();
    const intervalLabel = String(price?.interval_label || "").toLowerCase();
    return billingCycle.includes(interval) || intervalLabel.includes(interval);
  });
  return (
    matched?.id ??
    plan.prices[interval === "yearly" ? 1 : 0]?.id ??
    plan.prices[0]?.id ??
    null
  );
}

function handleMembershipPackageUpdate(value: string) {
  const id = Number(value);
  if (!Number.isFinite(id)) {
    selectedPlanId.value = null;
    selectedPriceId.value = null;
    selectedPlan.value = null;
    return;
  }

  selectPlan(id);
  selectedPriceId.value = resolvePriceIdForInterval(
    selectedPlan.value,
    selectedBillingInterval.value
  );
}

function handleMembershipBillingUpdate(value: "monthly" | "yearly") {
  selectedBillingInterval.value = value;
  selectedPriceId.value = resolvePriceIdForInterval(selectedPlan.value, value);
}

function getBillingIntervalFromSelection() {
  return selectedBillingInterval.value;
}

// New handler for free plans
async function handleApplyWithoutPrice() {
  try {
    isSubmitting.value = true;
    errorMessage.value = "";

    const companyId = getRouteCompanyId();
    if (!companyId) throw new Error("Invalid company id");

    const payload: Record<string, string | undefined> = {
      company_id: String(companyId),
      approved_application_id: approval.value.id ? String(approval.value.id) : undefined,
    };

    if (selectedPlanId.value) {
      payload.company_plan_id = String(selectedPlanId.value);
    }

    if (selectedPriceId.value) {
      payload.company_price_id = String(selectedPriceId.value);
    }

    const resp: any = await sendVendorRequestWithoutPrice(payload);
    // console.log({ resp });
    isSubmitted.value = true;
    // router.push({ name: "vendor.dashboard" });
  } catch (err) {
    console.error("Failed to apply without price", err);
    errorMessage.value =
      (err as Error)?.message || "Unable to apply for free plan. Please try again.";
  } finally {
    isSubmitting.value = false;
  }
}

async function loadCompany() {
  const id = getRouteCompanyId();
  if (!id) {
    company.value = null;
    errorMessage.value = "Invalid association id.";
    return;
  }

  isLoading.value = true;
  errorMessage.value = "";
  try {
    const response: any = await fetchCompanyDetails(id);
    const root = response?.data ?? response;
    const payload = root?.data ?? root;
    company.value = payload as CompanyDetail;
    if (hasCompanyPlans.value) {
      const firstPlanId = company.value?.company_plans?.[0]?.id ?? null;
      selectedPlanId.value = firstPlanId;
      selectedPlan.value = company.value?.company_plans?.[0] ?? null;
      selectedPriceId.value = resolvePriceIdForInterval(
        selectedPlan.value,
        selectedBillingInterval.value
      );
    } else {
      selectedPlanId.value = null;
      selectedPlan.value = null;
      selectedPriceId.value = null;
    }

    // Prefer company-specific publishable key when available.
    if (company.value?.company?.publishable_key) {
      stripeConfig.publishableKey = company.value.company.publishable_key;
      console.log("Loaded company details", stripeConfig.publishableKey);
    }
  } catch (error) {
    console.error(error);
    errorMessage.value = "Unable to load association. Please try again.";
    company.value = null;
  } finally {
    isLoading.value = false;
  }
}

async function handleApply() {
  if (isSubmitting.value) return;
  const companyId = getRouteCompanyId();
  if (!companyId) return;

  if (!hasCompanyPlans.value) {
    await handleApplyWithoutPrice();
    return;
  }

  if (!selectedPlanId.value || !selectedPriceId.value) return;

  // If selected price is zero, delegate to the free-handler and skip payment flow
  if (selectedPrice.value && Number(selectedPrice.value.amount) === 0) {
    handleApplyWithoutPrice();
    return;
  }

  try {
    isSubmitting.value = true;
    errorMessage.value = "";

    // Same response shape as `createVendorRequest()` (vendor_id, company_vendor_id, company_id).
    const vendorResponse: any = await sendVendorRequest({
      company_id: companyId,
      approved_application_id: approval.value.id ? String(approval.value.id) : undefined,
      company_plan_id: String(selectedPlanId.value),
      company_price_id: String(selectedPriceId.value),
    });

    const vendorId = vendorResponse?.vendor_id || vendorResponse?.data?.vendor_id;
    const companyVendorId =
      vendorResponse?.company_vendor_id || vendorResponse?.data?.company_vendor_id;

    if (!vendorId) throw new Error("Failed to create vendor request.");

    const intentResponse: any = await createVendorMembershipIntent({
      company_id: companyId,
      company_vendor_id: companyVendorId,
      company_plan_id: String(selectedPlanId.value),
      company_price_id: String(selectedPriceId.value),
      billing_interval: getBillingIntervalFromSelection(),
    });

    const intentPayload =
      intentResponse?.original?.data || intentResponse?.data || intentResponse;

    const clientSecret =
      intentPayload?.clientSecret ||
      intentPayload?.client_secret ||
      intentResponse?.clientSecret ||
      intentResponse?.client_secret ||
      intentResponse?.data?.clientSecret ||
      intentResponse?.data?.client_secret;

    const intentType =
      intentPayload?.intentType ||
      intentPayload?.intent_type ||
      intentPayload?.intentType?.replace?.("-", "_") ||
      intentPayload?.intent_type?.replace?.("-", "_") ||
      intentResponse?.data?.intentType ||
      intentResponse?.data?.intent_type ||
      "payment";

    const membershipId =
      intentPayload?.membershipId ||
      intentPayload?.membership_id ||
      intentResponse?.data?.membershipId ||
      intentResponse?.data?.membership_id;

    const intentId =
      intentPayload?.intentId ||
      intentPayload?.intent_id ||
      intentPayload?.stripeIntentId ||
      intentPayload?.stripe_intent_id ||
      intentResponse?.data?.intentId ||
      intentResponse?.data?.intent_id ||
      intentResponse?.data?.stripeIntentId ||
      intentResponse?.data?.stripe_intent_id;

    const stripeIntentId =
      intentPayload?.stripeIntentId ||
      intentPayload?.stripe_intent_id ||
      intentResponse?.stripeIntentId ||
      intentResponse?.stripe_intent_id ||
      intentResponse?.data?.stripeIntentId ||
      intentResponse?.data?.stripe_intent_id ||
      intentId;

    stripeConfig.publishableKey =
      intentPayload?.publishableKey ||
      intentPayload?.publishable_key ||
      intentPayload?.stripePublishableKey ||
      intentPayload?.stripe_publishable_key ||
      companyPublishableKey.value ||
      stripeConfig.publishableKey ||
      "";
    stripeConfig.stripeAccount =
      intentPayload?.stripeAccount ||
      intentPayload?.stripe_account ||
      intentPayload?.stripe_account_id ||
      intentPayload?.stripeAccountId ||
      intentPayload?.stripe_accountID ||
      intentPayload?.account ||
      intentPayload?.account_id ||
      intentPayload?.connect_account ||
      intentPayload?.connect_account_id ||
      intentPayload?.stripe_connect_account ||
      intentPayload?.stripe_connect_account_id ||
      intentPayload?.connectedAccountId ||
      intentPayload?.connected_account_id ||
      stripeConfig.stripeAccount ||
      "";

    if (!clientSecret) throw new Error("Missing client secret from payment response.");
    if (!paymentBlockRef.value) throw new Error("Payment form is not ready.");

    const billingDetails = {
      name: approval.value.businessInfo?.business_name || company.value?.name || "",
      email:
        approval.value.businessInfo?.business_email ||
        approval.value.contactInfo?.email ||
        "",
      phone:
        approval.value.businessInfo?.business_phone ||
        approval.value.contactInfo?.phone ||
        "",
      address: {
        line1: approval.value.addressInfo?.add1 || "",
        line2: approval.value.addressInfo?.add2 || "",
        city: approval.value.addressInfo?.city || "",
        state: approval.value.addressInfo?.state || "",
        postal_code: approval.value.addressInfo?.zip || "",
      },
    };

    await paymentBlockRef.value.validate();

    const confirmation =
      intentType === "setup" || intentType === "setup_intent"
        ? await paymentBlockRef.value.confirmSetup(clientSecret, billingDetails)
        : await paymentBlockRef.value.confirmPayment(clientSecret, billingDetails);

    const paymentIntentId = (confirmation as any).paymentIntentId;
    const setupIntentId = (confirmation as any).setupIntentId;
    const paymentMethodId = (confirmation as any).paymentMethodId;

    await finalizeVendorMembership({
      company_id: companyId,
      membership_id: membershipId,
      vendor_id: vendorId,
      payment_intent_id: paymentIntentId,
      setup_intent_id: setupIntentId,
      payment_method_id: paymentMethodId,
      stripe_intent_id: paymentIntentId || setupIntentId || stripeIntentId,
      intent_type: intentType,
      intent_id: intentId,
    });

    isSubmitted.value = true;
  } catch (error) {
    console.error("Failed to submit vendor membership request", error);
    errorMessage.value =
      (error as Error)?.message ||
      "Unable to proceed with application. Please try again.";
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(() => {
  void loadCompany();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (isSubmitted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(AppCard, { class: "success-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "56",
                color: "success"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-check-circle-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "success-title" }, "Application Submitted", -1)),
              _createElementVNode("p", _hoisted_4, " Your application has been submitted successfully" + _toDisplayString(companyDisplayName.value ? ` to ${companyDisplayName.value}` : "") + ". It is now under review. We will notify you once the review is complete. ", 1),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'vendor.dashboard' })))
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Back to Dashboard ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "18",
                  width: "2"
                }),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Loading association...", -1))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (company.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_v_icon, { size: "22" }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("mdi-card-account-details-star-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Membership Application", -1)),
                          _createElementVNode("p", null, _toDisplayString(hasCompanyPlans.value
                    ? "Review your approved business details and choose a membership plan."
                    : "Review your approved business details and submit your application."), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "review-section-title" }, "Company Information", -1)),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Name", -1)),
                              _createElementVNode("strong", null, _toDisplayString(company.value.name || "-"), 1)
                            ]),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "review-row review-row--title-bottom" }, [
                              _createElementVNode("span", null, "Address"),
                              _createElementVNode("strong", null, "test")
                            ], -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "review-section-title" }, "Business Information", -1)),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[10] || (_cache[10] = _createElementVNode("span", null, "Name", -1)),
                              _createElementVNode("strong", null, _toDisplayString(approval.value.businessInfo.business_name || "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _cache[11] || (_cache[11] = _createElementVNode("span", null, "Type", -1)),
                              _createElementVNode("strong", null, _toDisplayString(approval.value.businessInfo.business_type || "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _cache[12] || (_cache[12] = _createElementVNode("span", null, "Email", -1)),
                              _createElementVNode("strong", null, _toDisplayString(approval.value.businessInfo.business_email || "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _cache[13] || (_cache[13] = _createElementVNode("span", null, "Phone", -1)),
                              _createElementVNode("strong", null, _toDisplayString(approval.value.businessInfo.business_phone || "-"), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "review-section-title" }, "Business Address", -1)),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", null, "Address", -1)),
                              _createElementVNode("strong", null, _toDisplayString(approval.value.addressInfo.add1 || "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", null, "City", -1)),
                              _createElementVNode("strong", null, _toDisplayString(approval.value.addressInfo.city || "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", null, "State", -1)),
                              _createElementVNode("strong", null, _toDisplayString(approval.value.addressInfo.state || "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _cache[18] || (_cache[18] = _createElementVNode("span", null, "Zip", -1)),
                              _createElementVNode("strong", null, _toDisplayString(approval.value.addressInfo.zip || "-"), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "review-section-title" }, "Documents", -1)),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(approval.value.documents, (doc, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "review-row review-row--title-bottom",
                                key: index
                              }, [
                                _createElementVNode("strong", _hoisted_28, _toDisplayString(doc.type.split("_").join(" ") || "Document"), 1),
                                _createElementVNode("div", _hoisted_29, [
                                  (doc.url)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "review-file-thumb",
                                        src: doc.url,
                                        alt: doc.type || 'ID Proof (Front)'
                                      }, null, 8, _hoisted_30))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        (hasCompanyPlans.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "review-section-title" }, "Choose Membership Plans", -1)),
                              _createElementVNode("div", _hoisted_32, [
                                _createVNode(MembershipPlans, {
                                  company_id: getRouteCompanyId(),
                                  package_id: selectedPlanId.value ? String(selectedPlanId.value) : '',
                                  billing_interval: selectedBillingInterval.value,
                                  errors: {},
                                  "onUpdate:package_id": handleMembershipPackageUpdate,
                                  "onUpdate:billing_interval": handleMembershipBillingUpdate
                                }, null, 8, ["company_id", "package_id", "billing_interval"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (!isSubmitted.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (hasCompanyPlans.value && selectedPrice.value && Number(selectedPrice.value.amount) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "section-title" }, "Payment", -1)),
                                  _createVNode(PaymentBlock, {
                                    ref_key: "paymentBlockRef",
                                    ref: paymentBlockRef,
                                    publishableKey: stripeConfig.publishableKey || companyPublishableKey.value,
                                    stripeAccount: stripeConfig.stripeAccount,
                                    amount: selectedPrice.value.amount
                                  }, null, 8, ["publishableKey", "stripeAccount", "amount"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(AppButtonFlat, {
                                block: "",
                                "append-icon": "mdi-arrow-right",
                                loading: isSubmitting.value,
                                disabled: 
                  isSubmitting.value ||
                  (hasCompanyPlans.value && (!selectedPlanId.value || !selectedPriceId.value))
                ,
                                onClick: handleApply
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(hasCompanyPlans.value ? "Apply Now" : "Submit Application"), 1)
                                ]),
                                _: 1
                              }, 8, ["loading", "disabled"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(AppCard, {
                      key: 1,
                      class: "empty-card"
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("Association not found.", -1)
                      ]))]),
                      _: 1
                    }))
              ], 64))
        ]))
  ]))
}
}

})